import useResizeObserver from '@react-hook/resize-observer';
import { useCallback, useLayoutEffect, useState } from 'react';
export const useProperty = (element, selector, parentId, identifier, property = 'scrollHeight') => {
    const [value, setValue] = useState(0);
    const getElement = useCallback((el) => {
        const ref = el && 'current' in el ? el.current : el;
        return ref instanceof HTMLElement && ref;
    }, []);
    const getValue = useCallback((el) => {
        const ref = getElement(el);
        return ref ? ref[property] : 0;
    }, [getElement, property]);
    const setProperty = useCallback((el, input) => {
        const ref = getElement(el);
        if (ref) {
            const ancestor = getElement(ref.closest(selector));
            if (!ancestor) {
                return;
            }
            if (ancestor.style.getPropertyValue(`--${identifier}`) &&
                input === value) {
                return;
            }
            ancestor.style.setProperty(`--${identifier}`, `${input}px`);
            ancestor.style.setProperty(`--${identifier}-${parentId}`, `${input}px`);
            if (input !== value) {
                setValue(input);
            }
        }
    }, [getElement, identifier, parentId, selector, value]);
    const updateHandler = useCallback((el) => () => setProperty(el, getValue(el)), [getValue, setProperty]);
    useLayoutEffect(() => {
        const ref = getElement(element);
        if (ref) {
            const handler = updateHandler(ref);
            handler();
            ref.addEventListener('click', handler);
            ref.addEventListener('keydown', handler);
            return () => {
                ref.removeEventListener('click', handler);
                ref.removeEventListener('keydown', handler);
            };
        }
        return () => { };
    }, [element, getElement, updateHandler]);
    useResizeObserver(element, ({ target }) => updateHandler(target)());
    return value;
};
//# sourceMappingURL=useProperty.js.map